import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-maps-page',
    imports: [MatCardModule],
    templateUrl: './maps-page.component.html',
    styleUrl: './maps-page.component.scss'
})
export class MapsPageComponent {}